export default __webpack_public_path__ + "49ff3c0765a2a0534783564241b19958.svg";